type Props = {
  title: string;
  description?: string;
  children?: React.ReactElement;
};

const ResourcesHero = ({ title, description, children }: Props): React.ReactElement => {
  return (
    <>
      <div className="resources-hero-v2 z-1 xl:pb-32 relative">
        <div className="xl:pt-0 xl:pb-20 xl:flex main-container flex-row-reverse items-center justify-between pt-0 pb-16">
          <div className="xl:w-2/5 xl:mx-0 xl:px-0 px-12 mx-auto">&nbsp;</div>

          <div className="xl:mt-0 xl:text-left xl:w-3/5 text-center">
            <div className="ck-h2 font-semibold">{title}</div>
            {!!description && (
              <p className="ck-h5 xl:hidden max-w-3xl mx-auto mb-0 font-medium text-center text-gray-500">
                {description}
              </p>
            )}
          </div>
        </div>
      </div>
      <div className="main-container">{children}</div>
    </>
  );
};

ResourcesHero.defaultProps = {
  description: undefined,
  children: undefined,
};

export default ResourcesHero;
